import { useParams } from "react-router-dom";
import { isSupportedLng, type Lng } from "./languageDetection";

export {
  detectPreferredLng,
  isSupportedLng,
  supportedLngs,
} from "./languageDetection";
export type { Lng } from "./languageDetection";

/**
 * Helper for components to build locale-aware paths.
 * Example:
 *   const path = useLocalePath("about") // -> "/da/about" or "/en/about"
 *   const home = useLocalePath()        // -> "/da" or "/en"
 */
export function useLocalePath() {
  const { lng } = useParams();
  const safeLng: Lng = isSupportedLng(lng) ? lng : "en";
  return (segment?: string) =>
    `/${safeLng}${segment ? `/${segment.replace(/^\/+/, "")}` : ""}`;
}
